// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2-qlU","head":"ProcedureTableInfo_head__Kgj8m"};